import { EnrichmentTypeEnum } from '@aibees/elephant/types';
import type { IconProps } from '@aibees/shared/components';

export const getEnrichmentTypeLabel = (type: EnrichmentTypeEnum): string => {
  switch (type) {
    case EnrichmentTypeEnum.COMPANY:
      return 'Company';
    case EnrichmentTypeEnum.PERSON:
      return 'People';
    case EnrichmentTypeEnum.EMAIL:
      return 'Email';
    case EnrichmentTypeEnum.EMAIL_FINDER:
      return 'Email Finder';
    case EnrichmentTypeEnum.EMAIL_VERIFIER:
      return 'Email Verifier';
    default:
      return 'Unknown';
  }
};

export const getEnrichmentIconName = (
  type: EnrichmentTypeEnum
): IconProps['name'] => {
  switch (type) {
    case EnrichmentTypeEnum.COMPANY:
      return 'business';
    case EnrichmentTypeEnum.PERSON:
      return 'people-alt-outline';
    case EnrichmentTypeEnum.EMAIL:
      return 'email';
    case EnrichmentTypeEnum.EMAIL_FINDER:
      return 'email';
    case EnrichmentTypeEnum.EMAIL_VERIFIER:
      return 'email';
    default:
      return 'business';
  }
};

export const getEnrichmentIconColor = (
  type: EnrichmentTypeEnum
): IconProps['color'] => {
  switch (type) {
    case EnrichmentTypeEnum.COMPANY:
      return 'primary.500';
    case EnrichmentTypeEnum.PERSON:
      return 'success.500';
    case EnrichmentTypeEnum.EMAIL:
      return 'warning.500';
    case EnrichmentTypeEnum.EMAIL_FINDER:
      return 'warning.500';
    case EnrichmentTypeEnum.EMAIL_VERIFIER:
      return 'warning.500';
    default:
      return 'grey.500';
  }
};
